




















































































import { Component, Vue,Inject, Prop,Watch } from 'vue-property-decorator';
import Util from '@/lib/util'
import AbpBase from '@/lib/abpbase'
import PageRequest from '@/store/entities/page-request'
import AppConsts from '@/lib/appconst';
import _ from 'lodash';    
import ReceivePhysicalEntity from '@/store/entities/receive-physicals/receive-physical';
import ViewOrSelectSerialInfo from '@/store/entities/receive-physicals/view-or-select-serial-info';
import ViewOrSelectSerial from "@/views/components/view-or-select-serials.vue"
class  PageReceivePhysicalRequest extends PageRequest{
    keyword:string;
}

@Component({
    components: { 'view-or-select-serials':ViewOrSelectSerial }
})
export default class ReceivePhysical extends AbpBase{
    @Prop({ type: Number, default: 0 }) poId: number;
    @Prop({ type: Array, default: ()=>[] }) poLinePhysicals: Array<ReceivePhysicalEntity>;
    @Prop({ type: Boolean, default : false}) canReceivePhysical: Boolean;
    @Prop({ type: Array, default: ()=>[] }) poLinePhysicalsFilter: Array<ReceivePhysicalEntity>;
    @Prop({ type: Number, default: 0 }) sumPhysicalOrderQty: number;
    @Prop({ type: Number, default: 0 }) sumPhysicalRealQty: number;

    //filters
    pagerequest:PageReceivePhysicalRequest=new PageReceivePhysicalRequest();
    itemShowSerial: any = new ViewOrSelectSerialInfo();
    selectedserialNos: ViewOrSelectSerialInfo = new ViewOrSelectSerialInfo();
    lineIdSelected: number = 0;
    isShowItemShowSerial : boolean = false;
    poLinePhysicalProductKeyword : string = "";
    get store(){
        return this.$store.state.inboundException;
    }
    isClient() {
      return this.$store.state.session.client != null;
    }
    isTenant() {
      return this.$store.state.session.tenant!=null;
    }

    hasDeclarePermission()
    {
        return this.hasPermission('Operations.PurchaseOrders.DeclareOverShortQty');
    }
    get loading(){
        return this.$store.state.inboundException.loading;
    }

    viewOrSelectSerial(row:any,index:number){
        this.isShowItemShowSerial = true;
        this.itemShowSerial.lineId = row.poLineId;
        this.itemShowSerial.sku = row.sku;
        this.itemShowSerial.productName = row.productName;
        this.itemShowSerial.orderQty = row.orderQty;
        this.itemShowSerial.selectQty = row.physicalQty;
        this.$set(this.itemShowSerial, 'serialNosReceived', row.serialNosReceived);
        this.$set(this.itemShowSerial, 'serialNosAvailable', row.serialNosAvailable);
    }

    onSelectSerial(){
        _.forEach(this.poLinePhysicals, (item) => {
            if(item.poLineId == this.lineIdSelected){
                item.physicalQty = _.filter(this.selectedserialNos, function(o) { if (o.isReceived) return o }).length;
                item.serialNos = this.selectedserialNos;
            }
        });

        this.calculateSumPhysicalRealQty();
    }

    checkEditPhysicalQty(row:any,index:number){
        var editQty = row.physicalQty;
        if(editQty > row.orderQty)
        {
            editQty = row.orderQty;
        }
        var lineStoreIndex = _.findIndex(this.poLinePhysicals, {poLineId: row.poLineId})
        if(!Util.isNull(lineStoreIndex) && lineStoreIndex>=0)
        {
             this.poLinePhysicals[lineStoreIndex].physicalQty = editQty;
        }

        this.calculateSumPhysicalRealQty();
    };

    calculateSumPhysicalRealQty()
    {
        if(this.poLinePhysicals.length>0)
            this.sumPhysicalRealQty = _.sumBy(this.poLinePhysicals,'physicalQty');
    }

    saveReceivePhysical(){
        this.$Modal.confirm({
            title:this.L('Tips'),
            content:this.L('Confirm.ReceivePhysicalItem'),
            okText:this.L('Yes'),
            cancelText:this.L('No'),
            onOk:async()=>{
                await this.$store
                .dispatch({
                    type:'receivePhysical/receivePhysicalItem',
                    data: this.getParamReceivePhysical()
                })
                .then(() => {
                    Util.showSuccessMsg(this,"Success.ReceivePhysicalItemSuccess");
                    location.reload();
                });
                
            }
        });
    }

    searchpoLinePhysicalProductsPage(){
        var items =this.poLinePhysicals ;
        if (!Util.isEmpty(this.poLinePhysicalProductKeyword)) {
             items = items.filter((item) => item.sku.indexOf(this.poLinePhysicalProductKeyword) >= 0 || item.productName.indexOf(this.poLinePhysicalProductKeyword)>=0);
        } 
    }

    getParamReceivePhysical(){
        var param = {
            poId : this.poId,
            lines : []
        };

        _.forEach(this.poLinePhysicals, item => {
            if(item.serialNos == undefined){
                param.lines.push({
                    poLineId : item.poLineId, 
                    physicalQty : item.physicalQty, 
                    serialNos: item.serialNosAvailable
                });
            }
            else{
                param.lines.push({
                    poLineId : item.poLineId, 
                    physicalQty : item.physicalQty, 
                    serialNos: item.serialNos
                });
            }
            
        });

        return param;
    }
    
    get columns()
    {
        return [         
            {
                title: Util.L('SKU'),
                key: 'sku'
            },
            {
                title: Util.L('ProductName'),
                key: 'productName'
            },
            {
                title: `${this.L("OrderQty")} (${Util.toViewNumberString(this.sumPhysicalOrderQty)})`,
                key: 'orderQty',
                align:'right',
                render: (h, params) => {
                    return h("span", Util.toViewNumberString(params.row.orderQty))
                }
            },
            {
                title: `${this.L("PhysicalQty")} (${Util.toViewNumberString(this.sumPhysicalRealQty)})`,
                slot: 'action',
                align: 'right'
            }
        ];
    } 
    rowDetailClassName(row, index) {
        if (!this.canReceivePhysical && row.orderQty != row.physicalQty) {
            return 'demo-table-info-physical-row';
        } 

        return '';
    }

    async created(){
    }
}
